export const EUROPE_BERLIN_TIMEZONE = 'Europe/Berlin';
